import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { tap, catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  public apiEndPoint: string;
  public httpOptions: any;
  private httpClient: HttpClient;
  private httpHeaders: any;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  errorHandler(error: HttpErrorResponse) {
    return observableThrowError(error.message || 'Server Error');
  }

  get(
    action: string,
    parameters?: any,
    type?: string,
    token?: string,
    headers?: HttpHeaders
  ) {
    if (!headers) {
      headers = new HttpHeaders();

      headers = headers.append('Access-Control-Allow-Origin', '*');
    }

    if (type === 'preview') {
      headers = headers.append('X-Unpublished', '*');
    }

    if (type === 'form') {
      headers = headers.append(
        'Content-Type',
        'application/x-www-form-urlencoded'
      );
    } else {
      headers = headers.append('Content-Type', 'application/json');
    }

    this.httpOptions = {
      headers,
      observe: 'response' as any,
    };

    return this.httpClient
      .get(action, {
        headers,
        params: parameters,
      })
      .pipe(tap((data) => catchError(this.errorHandler)));
  }

  post(action: string, parameters?: any, type?: string, token?: string) {
    this.httpHeaders = new HttpHeaders();

    if (
      type === 'preview' ||
      window.location.toString().indexOf('preview') > 0
    ) {
      this.httpHeaders = this.httpHeaders.append('X-Unpublished', '1');
    }

    if (type === 'form') {
      this.httpHeaders = this.httpHeaders.append(
        'Content-Type',
        'application/x-www-form-urlencoded'
      );
    } else {
      this.httpHeaders = this.httpHeaders.append(
        'Content-Type',
        'application/json'
      );
    }

    /*if (!!token && token !== 'null') {
            this.httpHeaders = this.httpHeaders.append('Authorization', `${token}`);
        }*/

    this.httpOptions = {
      headers: this.httpHeaders,
      observe: 'response' as any,
    };

    return this.httpClient
      .post<any[]>(action, parameters, this.httpOptions)
      .pipe(tap((data) => catchError(this.errorHandler)));
  }
}
